import * as React from 'react';
import { Suspense } from 'react';

import classname from '@search/classname/src';
import { ApplicationIdEnum } from '@search/graphql-typings';

import {
    MinimalBanksMortgageProps
} from '@search/vtbeco-frontend-core/view/desktop/components/MinimalBanksMortgage';
import {
    minimalBanksMortgageParamsFromOffer,
    useMinimalBanksMortgageOverall
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/useMinimalBanksMortageState';
import { DATA_GTM } from '@search/vtbeco-frontend-core/domain/newbuilding/libs/constants';

import './styles.css';
import { Mortgage3Calc } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/mortgage3';

const cn = classname.bind(null, 'Mortgage');

const Mortgage = React.forwardRef<HTMLDivElement, {
    mortgageParams: MinimalBanksMortgageProps;
    mortgageDemandLink?: string;
}>(({
    mortgageParams,
    mortgageDemandLink
}, ref) => {
    const {
        minimalBanksMortgageOffers
    } = useMinimalBanksMortgageOverall(
        minimalBanksMortgageParamsFromOffer({
            ...mortgageParams,
            regionId: undefined,
            mortgageRegionId: mortgageParams.regionId
        })
    );

    if (! minimalBanksMortgageOffers?.length) {
        return null;
    }

    return (
        <div className={cn()} ref={ref}>
            <Suspense fallback=''>
                <Mortgage3Calc
                    withoutAuth
                    isNewBuilding
                    isPreferentialNbCondition
                    realtyType='ProfOfferFlat'
                    mortgageRegionId={mortgageParams.regionId}
                    purpose={mortgageParams.purpose}
                    locationPlacement='калькулятор'
                    applicationId={ApplicationIdEnum.NewBuildingsDesktop}
                    term={mortgageParams.term}
                    ownAmount={mortgageParams.ownAmount}
                    propertyCost={mortgageParams.propertyCost}
                    gtmStarterModalSendedId={DATA_GTM.MORTGAGE_STARTER_MODAL_SEND_ID}
                    gtmSendClick={DATA_GTM.MORTGAGE_SEND_CLICK}
                    gtmShowMoreClick={DATA_GTM.MORTGAGE_SHOW_MORE_CLICK}
                    mortgageDemandLink={mortgageDemandLink}
                    gtmSendData={{
                        event: 'nb_ib_form',
                        action: 'send',
                        place: 'calc',
                        page_type: 'card',
                    }}
                    gtmShowData={{
                        event: 'nb_ib_form',
                        action: 'open',
                        place: 'calc',
                        page_type: 'card',
                    }}
                />
            </Suspense>
        </div>
    );
});

export default Mortgage;
